import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["callback"],
  _excluded2 = ["callback"];
import { getAdminBoxMetadata, updateAdminBoxMetadata } from '@frontegg/rest-api/metadata';
import { call, put, takeLeading } from 'redux-saga/effects';
import { actions } from '../reducer';
import { delay } from '../utils';
import { mapMetaDataObjectToActions } from './utils';
import { errorHandler } from '../../utils';
export function* loadTenantMetadata() {
  yield put(actions.setCustomLoginState({
    loading: true
  }));
  try {
    const tenantMetadata = yield call(getAdminBoxMetadata);
    yield put(actions.setCustomLoginState({
      tenantMetadata,
      loading: false
    }));
  } catch (e) {
    yield put(actions.setCustomLoginState({
      loading: false,
      error: errorHandler(e)
    }));
  }
}
function* updateTenantMetadata(_ref) {
  let {
      payload: {
        callback
      }
    } = _ref,
    state = _objectWithoutPropertiesLoose(_ref.payload, _excluded);
  try {
    yield put(actions.setCustomLoginState({
      error: null,
      saving: true
    }));
    const requestActions = mapMetaDataObjectToActions(state);
    if (requestActions.length === 0) {
      throw new Error('No changes to update');
    }
    yield call(updateAdminBoxMetadata, {
      actions: requestActions
    });
    const tenantMetadata = yield call(getAdminBoxMetadata);
    yield put(actions.setCustomLoginState({
      tenantMetadata,
      saving: false
    }));
    callback == null ? void 0 : callback(true);
  } catch (e) {
    yield put(actions.setCustomLoginState({
      error: errorHandler(e, 'No changes to update'),
      saving: false
    }));
    callback == null ? void 0 : callback(null, e);
  }
}
export function* customLoginSagas() {
  yield takeLeading(actions.loadTenantMetadata, loadTenantMetadata);
  yield takeLeading(actions.updateTenantMetadata, updateTenantMetadata);
}

// /*********************************
//  *  Preview Sagas
//  *********************************/

function* loadCustomLoginStateMock() {
  yield put(actions.setCustomLoginState({
    loading: true
  }));
  yield delay();
  yield put(actions.setCustomLoginState({
    loading: false
  }));
}
function* updateCustomLoginMetadataMock(_ref2) {
  let {
      payload: {
        callback
      }
    } = _ref2,
    payload = _objectWithoutPropertiesLoose(_ref2.payload, _excluded2);
  yield put(actions.setCustomLoginState({
    loading: true,
    error: null
  }));
  yield delay();
  yield put(actions.setCustomLoginState({
    loading: false,
    error: null
  }));
  callback == null ? void 0 : callback(true);
}
export function* customLoginSagasMock() {
  yield takeLeading(actions.loadTenantMetadata, loadCustomLoginStateMock);
  yield takeLeading(actions.updateTenantMetadata, updateCustomLoginMetadataMock);
}